// DocumentTitle.js - Utility for managing document titles throughout the app

/**
 * Sets the document title with optional prefix/suffix
 * @param {string} title - The main title to display
 * @param {string} [suffix] - Optional suffix (e.g. company name)
 */
export const setDocumentTitle = (title, suffix = '') => {
  if (suffix) {
    document.title = `${title} - ${suffix}`;
  } else {
    document.title = title;
  }
};

/**
 * Default/fallback title for the application
 */
export const DEFAULT_TITLE = 'Custom CRM';

/**
 * Page titles for different routes
 */
export const PAGE_TITLES = {
  '/': 'Dashboard',
  '/leads': 'Leads',
  '/deals': 'Deals',
  '/pipeline': 'Deal Pipeline',
  '/calendar': 'Calendar',
  '/tasks': 'Tasks',
  '/kpis': 'KPIs',
  '/employees': 'Employees',
  '/mailer': 'Email Marketing',
  '/chat': 'Team Chat',
  '/settings': 'Settings',
  '/login': 'Login',
  '/register': 'Register'
};